import { toDateIST } from '@/utils/date';

export function startOfWeek(d) {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  // Monday as week start
  const day = x.getDay();
  const diff = day === 0 ? -6 : 1 - day;
  x.setDate(x.getDate() + diff);
  return x;
}

export function startOfMonth(d) {
  const x = new Date(d.getFullYear(), d.getMonth(), 1);
  x.setHours(0, 0, 0, 0);
  return x;
}

export function addDays(d, n) {
  const x = new Date(d);
  x.setDate(x.getDate() + n);
  return x;
}

export function isoDate(d) {
  return toDateIST(d);
}

export function daysInRange(from, count) {
  return Array.from({ length: count }, (_, i) => addDays(from, i));
}

export function monthGrid(anchor) {
  const first = startOfMonth(anchor);
  const start = startOfWeek(first);
  // 6 weeks covers every month layout
  return daysInRange(start, 42);
}

export function formatDay(d) {
  return d.toLocaleDateString('en-IN', { weekday: 'short', day: '2-digit', timeZone: 'Asia/Kolkata' });
}

export function formatMonthLabel(d) {
  return d.toLocaleDateString('en-IN', { month: 'long', year: 'numeric', timeZone: 'Asia/Kolkata' });
}

export function endOfMonth(d) {
  return new Date(d.getFullYear(), d.getMonth() + 1, 0);
}

/** Inclusive publish/allocate bounds for the visible period (not padded month grid). */
export function periodBounds(period, anchor) {
  if (period === 'month') {
    const from = startOfMonth(anchor);
    const to = endOfMonth(anchor);
    return { fromIso: isoDate(from), toIso: isoDate(to) };
  }
  const from = startOfWeek(anchor);
  return { fromIso: isoDate(from), toIso: isoDate(addDays(from, 6)) };
}

/** Rough count of matching weekdays between two ISO dates (inclusive). */
export function countWeekdayMatches(fromIso, toIso, daysOfWeek) {
  const set = new Set(daysOfWeek || []);
  if (!set.size || !fromIso || !toIso) return 0;
  const [fy, fm, fd] = fromIso.split('-').map(Number);
  const [ty, tm, td] = toIso.split('-').map(Number);
  let cur = new Date(fy, fm - 1, fd);
  const end = new Date(ty, tm - 1, td);
  let n = 0;
  while (cur <= end) {
    const monBased = cur.getDay() === 0 ? 6 : cur.getDay() - 1;
    if (set.has(monBased)) n += 1;
    cur = addDays(cur, 1);
  }
  return n;
}

export const WEEKDAYS = [
  { v: 0, l: 'Mon' }, { v: 1, l: 'Tue' }, { v: 2, l: 'Wed' },
  { v: 3, l: 'Thu' }, { v: 4, l: 'Fri' }, { v: 5, l: 'Sat' }, { v: 6, l: 'Sun' },
];

export const SHIFT_PRESETS = [
  { id: 'morning', label: 'Morning OPD', start: '09:00', end: '13:00', location: 'OPD Block A — Morning' },
  { id: 'afternoon', label: 'Afternoon OPD', start: '14:00', end: '17:00', location: 'OPD Block A — Afternoon' },
  { id: 'evening', label: 'Evening', start: '17:00', end: '20:00', location: 'OPD Block B — Evening' },
];
